export const CreditLineCard = require("./creditLineCard.png");
export const DehaatHindi = require("./dehaat-hindi.webp");
export const PaymentIcon = require("./payment.webp");
